import type { BaseTrackingValues } from "packages/membership/tracking/types"
import type { SlideId } from "types"

export type DiscoveryJourneySlides = {
  id: SlideId
}

export type DiscoveryJourneyApiResponse = {
  slides: DiscoveryJourneySlides[]
}

export type SlideButtonActions = {
  backToPreviousSlide?: () => void
  goToNextSlide?: () => void
}

export type BenefitsSlideProps = {
  navigateToMemberBenefitsPage?: () => void
  isActiveBenefitsLastSlide?: boolean
  isRedeemedBenefitsLastSlide?: boolean
}

export type NoActiveMembershipSlideProps = {
  navigateToJoinNowPage?: () => void
}

export type SlideProps = SlideButtonActions &
  BenefitsSlideProps &
  NoActiveMembershipSlideProps & {
    slide: SlideId
  }

export const baseTrackingValues: BaseTrackingValues = {
  target: "discovery_journey_modal",
  location: "discovery_journey_modal",
}
